export const PaginationDots = () => (
    <svg
        width='64'
        height='24'
        viewBox='0 0 64 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect x='0.5' y='0.5' width='63' height='23' rx='11.5' fill='#99CFE0' />
        <rect
            x='0.5'
            y='0.5'
            width='63'
            height='23'
            rx='11.5'
            stroke='#E5F3F7'
        />
        <rect x='8' y='8' width='8' height='8' rx='4' fill='white' />
        <rect x='28' y='8' width='8' height='8' rx='4' fill='#0088B2' />
        <rect x='48' y='8' width='8' height='8' rx='4' fill='#0088B2' />
    </svg>
);
